/*eslint-disable*/
export const messages = {
  // System notices (truncation / safety refusal)
  "This answer was shortened because it reached the length limit and may be incomplete.": "यह उत्तर लंबाई की सीमा तक पहुँचने के कारण छोटा कर दिया गया है और अधूरा हो सकता है।",
  "This request can't be answered due to safety guidelines. Please rephrase or ask about a different topic.": "सुरक्षा दिशानिर्देशों के कारण इस अनुरोध का उत्तर नहीं दिया जा सकता। कृपया इसे दोबारा लिखें या किसी अन्य विषय के बारे में पूछें।",
  // Common UI elements
  "Cancel": "रद्द करें",
  "Change theme": "थीम बदलें",
  "Clear chat": "चैट साफ़ करें",
  "Clear chat history": "चैट इतिहास साफ़ करें",
  "Connecting...": "कनेक्ट हो रहा है...",
  "Continue": "जारी रखें",
  "Decrease font size": "फ़ॉन्ट आकार घटाएँ",
  "Disclaimer": "अस्वीकरण",
  "Enter your message...": "अपना संदेश दर्ज करें...",
  "Type your message...": "अपना संदेश दर्ज करें...",
  "Error": "त्रुटि",
  "Font size": "फ़ॉन्ट आकार",
  "Increase font size": "फ़ॉन्ट आकार बढ़ाएँ",
  "Language": "भाषा",
  "MJ Lab": "एमजे लैब",
  "Reset font size": "फ़ॉन्ट आकार रीसेट करें",
  "Respond time: {time}s": "प्रतिक्रिया समय: {time}s",
  "Response time:": "प्रतिक्रिया समय:",
  "Send": "भेजें",
  "Settings": "सेटिंग्स",
  "Support the project": "परियोजना का समर्थन करें",
  "System": "सिस्टम",
  "Theme": "थीम",
  "Thinking...": "विचार कर रहा है...",
  "Toggle theme": "थीम टॉगल करें",
  "You asked:": "आपने पूछा:",
  
  // Headers
  "Hello, I am {{name}}, an AI assistant made by MJ.": "नमस्ते, मैं {{name}} हूँ, MJ द्वारा बनाया गया एक AI सहायक।",
  "I am expert in Ministry of Commerce laws and regulations for Saudi Arabia.": "मैं सऊदी अरब के वाणिज्य मंत्रालय के कानूनों और नियमों की विशेषज्ञ हूँ।",
  "Ask me a question, and I will gladly answer you.": "मुझसे एक प्रश्न पूछें, और मैं खुशी से आपको उत्तर दूंगा।",
  "Do not share confidential data.": "गोपनीय डेटा साझा न करें।",
  "I am powered using": "मैं इसका उपयोग करके संचालित हूँ",
  "Ministry of Commerce Laws Expert": "MoC कानून विशेषज्ञ",
  "by MJ": "MJ द्वारा",
  "Mila": "Mila",
  
  // Disclaimer
  "Disclaimer: {{name}} is an experimental AI assistant designed to respond using data from Saudi Ministry of Commerce laws and regulations, avoiding assumptions or inaccuracies. I am not responsible for its behavior or the correctness of its responses.": "**अस्वीकरण:** {{name}} एक प्रयोगात्मक AI सहायक है जो सऊदी अरब के वाणिज्य मंत्रालय के कानूनों और नियमों से डेटा का उपयोग करके प्रतिक्रिया देने के लिए डिज़ाइन किया गया है, मान्यताओं या अशुद्धियों से बचते हुए। मैं इसके व्यवहार या इसकी प्रतिक्रियाओं की सटीकता के लिए जिम्मेदार नहीं हूँ।",
  
  // Frameworks
  "Automatic detection": "स्वचालित पहचान",
  
  // A. Business Formation and Identity
  "MOC_COMPANIES_LAW": "A1. वा.मं. कंपनी कानून",
  "MOC_PROFESSIONAL_COMPANIES_LAW": "A2. वा.मं. पेशेवर कंपनी कानून",
  "MOC_COMMERCIAL_REGISTER_LAW": "A3. वा.मं. वाणिज्यिक रजिस्टर कानून",
  "MOC_MINISTRY_OF_COMMERCE_LAW": "A4. वाणिज्य मंत्रालय कानून",
  "MOC_TRADE_NAMES_LAW": "A5. वा.मं. व्यापार नाम कानून",
  "MOC_GCC_TRADEMARK_LAW": "A6. GCC ट्रेडमार्क कानून",
  
  // B. Financial Instruments, Security, and Insolvency
  "MOC_COMMERCIAL_PAPERS_LAW": "B1. वा.मं. वाणिज्यिक पत्र कानून",
  "MOC_COMMERCIAL_PLEDGE_LAW": "B2. वा.मं. वाणिज्यिक प्रतिज्ञा कानून",
  "MOC_MOVABLE_PROPERTY_SECURITY_LAW": "B3. वा.मं. चल संपत्ति सुरक्षा कानून",
  "MOC_INSOLVENCY_LAW": "B4. वा.मं. दिवालियापन कानून",
  
  // C. Commercial Relationships and Trade
  "MOC_COMMERCIAL_AGENCIES_LAW": "C1. वा.मं. वाणिज्यिक एजेंसी कानून",
  "MOC_FRANCHISE_LAW": "C2. वा.मं. फ्रेंचाइज़ कानून",
  "MOC_ECOMMERCE_LAW": "C3. वा.मं. ई-कॉमर्स कानून",
  "MOC_CHAMBERS_OF_COMMERCE_LAW": "C4. वा.मं. वाणिज्य मंडल कानून",
  
  // D. Commercial Records and Information
  "MOC_COMMERCIAL_BOOKS_LAW": "D1. वा.मं. वाणिज्यिक पुस्तक कानून",
  "MOC_COMMERCIAL_DATA_LAW": "D2. वा.मं. वाणिज्यिक डेटा कानून",
  "MOC_PUBLIC_WAREHOUSING_LAW": "D3. वा.मं. सार्वजनिक भंडारण कानून",
  
  // E. Standards, Quality, and Regulated Products
  "MOC_STANDARDS_METROLOGY_LAW": "E1. वा.मं. मानक और माप विज्ञान कानून",
  "MOC_CALIBRATION_MEASUREMENT_LAW": "E2. वा.मं. अंशांकन और माप कानून",
  "MOC_PRIVATE_LABORATORIES_LAW": "E3. वा.मं. निजी प्रयोगशाला कानून",
  "MOC_PRECIOUS_METALS_GEMSTONES_LAW": "E4. वा.मं. बहुमूल्य धातु और रत्न कानून",
  "MOC_CHEMICALS_IMPORT_MANAGEMENT_LAW": "E5. वा.मं. रसायन आयात प्रबंधन कानून",
  
  // F. Professional Regulation and Oversight
  "MOC_ACCOUNTING_AUDITING_LAW": "F1. वा.मं. लेखांकन और लेखापरीक्षा कानून",
  "MOC_VALUERS_LAW": "F2. वा.मं. मूल्यांकनकर्ता कानून",
  "MOC_ENGINEERS_LAW": "F3. वा.मं. इंजीनियर कानून",
  
  // G. Compliance and Dispute Resolution
  "MOC_ANTI_CONCEALMENT_LAW": "G1. वा.मं. छिपाव विरोधी कानून",
  "MOC_ANTI_MONEY_LAUNDERING_LAW": "G2. वा.मं. मनी लॉन्ड्रिंग विरोधी कानून",
  "MOC_ARBITRATION_LAW": "G3. वा.मं. मध्यस्थता कानून",
  "MOC_COMBATING_COMMERCIAL_ADULTERATION_LAW": "G4. वा.मं. वाणिज्यिक मिलावट विरोधी कानून",
  "MOC_GCC_COMBATING_DUMPING_LAW": "G5. GCC डंपिंग विरोधी कानून",
  
  // Models
  "Claude by Anthropic": "Anthropic द्वारा Claude",
  "DeepSeek by Groq": "Groq द्वारा DeepSeek",
  "MJ Lab Mode": "MJ लैब मोड",
  
  // Error messages
  "An error occurred": "एक त्रुटि हुई",
  "Failed to change language": "भाषा बदलने में विफल",
  "Please try again": "कृपया पुनः प्रयास करें",
  "Connection lost": "कनेक्शन खो गया",
  "Reconnecting...": "पुनः कनेक्ट हो रहा है...",
  "Nothing to clear": "साफ़ करने के लिए कुछ नहीं",
  "All messages cleared": "सभी संदेश साफ़ किए गए",
  "All data cleared": "सभी डेटा साफ़ किया गया",
  "Storage limit reached": "स्टोरेज सीमा पहुंच गई",
  "Some older messages were removed to save space.": "स्थान बचाने के लिए कुछ पुराने संदेश हटा दिए गए हैं।",
  
  // Character count
  "{{remainingChars}} character left": "{{remainingChars}} अक्षर शेष",
  "{{remainingChars}} characters left": "{{remainingChars}} अक्षर शेष",
  
  // Additional keys
  "Font Size": "फ़ॉन्ट आकार",
  "Language changed to {{locale}}": "भाषा {{locale}} में बदली गई",
  "Select language": "भाषा चुनें",
  "Support": "सहायता",
  
  // Brand names (do not translate)
  "Mila": "Mila",
  
  // Message actions
  "Message copied to clipboard": "संदेश क्लिपबोर्ड पर कॉपी किया गया",
  "Read": "पढ़ें",
  "Summarize": "सारांश",
  
  // Ice Breakers Dialog
  "Message Suggestions": "संदेश सुझाव",
  "Select a question to quickly start a conversation about Saudi Ministry of Commerce laws.": "सऊदी वाणिज्य मंत्रालय के कानूनों के बारे में बातचीत जल्दी शुरू करने के लिए एक प्रश्न चुनें।",
  "What are the main requirements under the Companies Law for establishing a limited liability company in Saudi Arabia?": "सऊदी अरब में सीमित देयता वाली कंपनी स्थापित करने के लिए कंपनी कानून के तहत मुख्य आवश्यकताएं क्या हैं?",
  "How does the Commercial Agencies Law regulate relationships between foreign companies and Saudi agents?": "वाणिज्यिक एजेंसी कानून विदेशी कंपनियों और सऊदी एजेंटों के बीच संबंधों को कैसे नियंत्रित करता है?",
  "What protections does the Saudi E-commerce Law provide for online consumers and businesses?": "सऊदी ई-कॉमर्स कानून ऑनलाइन उपभोक्ताओं और व्यवसायों को क्या सुरक्षा प्रदान करता है?",
  
  // Audio Player Dialog
  "AI Summary": "AI सारांश",
  "Listen to the summarized response using our AI Service.": "हमारी AI सेवा का उपयोग करके सारांश वाले उत्तर को सुनें।",
  "Generating summary...": "सारांश बना रहा है...",
  "Preparing audio...": "ऑडियो तैयार कर रहा है...",
  
  // Audio Player Error Messages
  "Failed to process text. Please try again.": "टेक्स्ट प्रोसेस करने में विफल। कृपया पुनः प्रयास करें।",
  "Failed to auto-play audio. Click play to try again.": "ऑडियो ऑटो-प्ले करने में विफल। पुन: प्रयास करने के लिए प्ले पर क्लिक करें।",
  "Failed to load audio. Please try again.": "ऑडियो लोड करने में विफल। कृपया पुनः प्रयास करें।",
  "Audio playback was aborted.": "ऑडियो प्लेबैक रोक दिया गया।",
  "Network error occurred while loading audio.": "ऑडियो लोड करते समय नेटवर्क त्रुटि हुई।",
  "Audio decoding failed.": "ऑडियो डिकोडिंग विफल।",
  "Audio format not supported.": "ऑडियो प्रारूप समर्थित नहीं है।",
  "Failed to setup audio playback": "ऑडियो प्लेबैक सेटअप करने में विफल",
  "Failed to generate speech": "भाषण उत्पन्न करने में विफल",
  "Failed to generate audio. Please try again.": "ऑडियो उत्पन्न करने में विफल। कृपया पुनः प्रयास करें।",
  "Failed to play audio. Please try again.": "ऑडियो चलाने में विफल। कृपया पुनः प्रयास करें।"
};